var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarEmpty = function SvgAvatarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 8c-8.142 0-14.766 6.624-14.766 14.766S23.858 37.531 32 37.531s14.766-6.624 14.766-14.765S40.142 8 32 8m18.371 39.178c-4.042-4.105-9.401-6.365-15.09-6.365H28.72c-5.689 0-11.048 2.26-15.09 6.365-4.023 4.084-6.238 9.476-6.238 15.181A1.64 1.64 0 0 0 9.032 64H54.97a1.64 1.64 0 0 0 1.64-1.64c0-5.706-2.215-11.098-6.238-15.182z"
  })));
};
export default SvgAvatarEmpty;